import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/apiClient";

export default function ReserveSettings() {
  const [settings, setSettings] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let current = true;
    apiFetch("/api/reserves/settings", { includeBearer: true }).then(async (response) => {
      if (response.ok && current) setSettings(await response.json());
    }).catch(() => {});
    return () => { current = false; };
  }, []);
  const toggle = async () => {
    setBusy(true); setError("");
    try {
      const response = await apiFetch("/api/reserves/settings", { method: "PUT", includeBearer: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ enabled: !settings.enabled }) });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || "Modification refusée");
      setSettings(payload);
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  if (!settings) return null;
  return <section className="rounded-lg border border-gray-700 bg-gray-800 p-6 text-white">
    <h3 className="text-lg font-semibold">Articles en réserve</h3>
    <p className="my-3 text-sm text-gray-300">Permettre de mettre en réserve la valeur d’articles payés et non remis. Désactiver ne supprime pas les soldes existants.</p>
    <button type="button" role="switch" aria-checked={settings.enabled} disabled={busy || !settings.ready || settings.consultationOnly} onClick={toggle} className="rounded-lg bg-amber-300 px-4 py-2 text-slate-950 disabled:opacity-50">{settings.enabled ? "Activé" : "Désactivé"}</button>
    {!settings.ready && <p className="mt-2 text-sm text-amber-200">Activation indisponible tant que les validations du parcours ne sont pas terminées.</p>}
    {settings.consultationOnly && <p className="mt-2 text-sm">Ce réglage se modifie sur le serveur local de l’établissement.</p>}
    {error && <p role="alert" className="mt-2 text-red-300">{error}</p>}
  </section>;
}
